export const SHOW_THIRD_PARTY_MODAL = 'SHOW_THIRD_PARTY_MODAL';
export const showThirdPartyModal = (flag) => ({
  type: SHOW_THIRD_PARTY_MODAL,
  showThirdPartyModal: flag
});

export const TARGET_URL = 'TARGET_URL';
export const targetURL = (url) => ({
  type: TARGET_URL,
  targetURL: url
});
